import { render, staticRenderFns } from "./CategoryTypeDelete.vue?vue&type=template&id=16b633bc"
import script from "./CategoryTypeDelete.vue?vue&type=script&lang=js"
export * from "./CategoryTypeDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports